import styled, { css } from 'styled-components';

const Price = styled.div<{ $isClubPrice?: boolean }>`
    grid-area: price;
    text-align: end;

${({ $isClubPrice }) =>
    $isClubPrice &&
    css`
            color: ${({ theme }) => theme.ColorTextSale};
        `}

`;

export default Price;
